module.exports = __webpack_public_path__ + "img/awards_secondplace.155dfe91.png";